import { gql } from '@apollo/client';

export const fetchtxaBalanceDetails = gql`
  query fetchtxaBalanceDetails($id: ID!) {
    transactionAccount(id: $id) {
      id
      transactionAccountNumber
      transactionAccountBalanceEntity {
        invoiceNumber
        endingAmount
      }
    }
  }
`;
